var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerformanceVoiceClickedOrg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "performance1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6213",
    "data-name": "Rectangle 6213",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_127",
    "data-name": "Union 127",
    d: "M17.116,269.1A2.118,2.118,0,0,1,15,266.984V255.116A2.118,2.118,0,0,1,17.116,253H28.985a2.119,2.119,0,0,1,2.116,2.116v11.868a2.119,2.119,0,0,1-2.116,2.116Zm-.522-13.984v11.868a.515.515,0,0,0,.522.521H28.985a.516.516,0,0,0,.521-.521V255.116a.516.516,0,0,0-.521-.522H17.116A.516.516,0,0,0,16.594,255.116Zm8.955,10.028v-.138a2.5,2.5,0,1,0-5,0v.138H18.956v-.138a4.105,4.105,0,0,1,1.983-3.486,2.774,2.774,0,1,1,4.224,0,4.107,4.107,0,0,1,1.982,3.486v.138Zm-3.68-5.413a1.181,1.181,0,1,0,1.181-1.181A1.168,1.168,0,0,0,21.869,259.731Z",
    transform: "translate(-11.05 -249.05)",
    fill: "#fd581f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformanceVoiceClickedOrg);
export default __webpack_public_path__ + "static/media/performance_voice_clicked_org.e2c7f6916b8c31924e0e8945c3230691.svg";
export { ForwardRef as ReactComponent };